import PageTransition from '@/components/ui/PageTransition'
import HeroSection from '@/components/home/HeroSection'
import WorkGrid from '@/components/home/WorkGrid'
import AboutSection from '@/components/home/AboutSection'

export default function HomePage() {
  return (
    <PageTransition>
      <HeroSection />
      <WorkGrid />
      <AboutSection />
    </PageTransition>
  )
}
